'use client';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import './page.scss';

export default function Page() {
  const t = useTranslations();
  return (
    <section className="tnc">
      <div
        className="tnc-title"
        dangerouslySetInnerHTML={{
          __html: t.raw('Smile.upload.popup.tnc.title')
        }}
      ></div>
      <div className="content-wrapper">
        {t.rich('Smile.upload.popup.tnc.content', {
          b: (text) => <b>{text}</b>,
          home: (text) => (
            <Link
              prefetch={false}
              className="link"
              style={{wordBreak: 'break-all'}}
              href={`${text}`}
            >
              {text}
            </Link>
          ),
          tou: (text) => (
            <Link
              prefetch={false}
              className="link"
              target="_blank"
              href={t('Smile.upload.popup.tnc.tou')}
            >
              {text}
            </Link>
          ),
          pp: (text) => (
            <Link
              prefetch={false}
              className="link"
              target="_blank"
              href={t('Smile.upload.popup.tnc.privacy')}
            >
              {text}
            </Link>
          )
        })}
      </div>
    </section>
  );
}
